import React, {useEffect, useState} from 'react';
import {Space, Button, notification} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import attendeesImg from './../../../Assets/svgs/attendees.svg'; // Replace with the correct path
import './style.css';
import useLocalization from '../../../Localization';

const AddAttendeeeComponent = ({
  addRow,
  disable = false,
  setDisablePaymentClicks,
  buttonText = null,
  showVendorRepLimitAlert = false,
  alignRight = false,
}) => {
  const {ApplicationString} = useLocalization();
  const [showVendorErrorMessage, setShowVendorErrorMessage] = useState(false);

  useEffect(() => {
    if (showVendorRepLimitAlert) {
      setShowVendorErrorMessage(true);
    } else {
      setShowVendorErrorMessage(false);
    }
  }, [showVendorRepLimitAlert]);

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          justifyContent: alignRight ? 'flex-end' : 'center',
        }}>
        <Space
          direction='vertical'
          size='middle'
          style={{
            width: alignRight ? 'auto' : '100%',
            alignItems: alignRight ? 'flex-end' : 'center',
          }}>
          <Button
            id='add-attendee'
            className={'add-attendee'}
            disabled={disable || showVendorErrorMessage}
            onClick={() => {
              if (showVendorRepLimitAlert) {
                notification.error({
                  message:
                    ApplicationString[
                      'adminActionsDropdownComponent.addAdditionalAttendee.vendorRepLimitExhausted.title'
                    ],
                  description:
                    ApplicationString[
                      'adminActionsDropdownComponent.addAdditionalAttendee.vendorRepLimitExhausted'
                    ],
                });
                return;
              }
              setDisablePaymentClicks && setDisablePaymentClicks(true);
              addRow();
            }}>
            {buttonText
              ? buttonText
              : ApplicationString[
                  'adminActionsDropdownComponent.addAdditionalAttendee'
                ]}{' '}
            <PlusOutlined />
          </Button>
          {showVendorErrorMessage && (
            <div
              style={{
                color: 'red',
                fontSize: '12px',
                fontWeight: 'bold',
                textAlign: 'center',
              }}>
              {
                ApplicationString[
                  'adminActionsDropdownComponent.addAdditionalAttendee.vendorRepLimitExhausted'
                ]
              }
            </div>
          )}
        </Space>
      </div>
    </React.Fragment>
  );
};

export default AddAttendeeeComponent;
